import script from "./PrivacyPolicyBgView.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicyBgView.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPolicyBgView.vue?vue&type=style&index=0&id=21abe75c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21abe75c"]])

export default __exports__